module.exports = __webpack_public_path__ + "static/img/3.3bec538.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/gbw/3.jpg
// module id = YKWz
// module chunks = 1